export interface StrategicInitiativeData {
  id: string;
  rootId: string;
  description: string;
  pillar: string;
  threshold: number;
  version: number;
  updatedBy: string;
  updateDateTime: number;

  title?: string;
}

export interface StrategicInitiativePillar {
  rootId: string;
  pillar: string;
  title: string;
}

export const emptyStrategicInitiativeData = () => ({
  id: "",
  rootId: "",
  description: "",
  pillar: "",
  threshold: 0,
  version: 1,
  updatedBy: "",
  updateDateTime: Date.now(),
});

export interface StrategicInitiativeRequest {
  description: string;
  pillar: string;
  threshold: number;
}
